<template>
  <v-list class="pt-20 text-left mh100">
    <h2 class="ml-3">Other Contact Information</h2>
    <v-divider></v-divider>
    <br />

    <h3 class="ml-3">Other Contact 1</h3>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Relation :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content>
            {{
              otherContactInfo &&
              otherContactInfo.length &&
              otherContactInfo[0].relation
                ? otherContactInfo[0].relation
                : "-"
            }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Name :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content
            v-if="
              otherContactInfo &&
              otherContactInfo.length &&
              otherContactInfo[0].name
            "
          >
            <Phone :phone="otherContactInfo[0].name" />
          </v-list-tile-content>
          <v-list-tile-content v-else>-</v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Phone :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content
            v-if="
              otherContactInfo &&
              otherContactInfo.length &&
              otherContactInfo[0].phone
            "
          >
            <Phone :phone="otherContactInfo[0].phone" />
          </v-list-tile-content>
          <v-list-tile-content v-else>-</v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <br />

    <h3 class="ml-3">Other Contact 2</h3>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Relation :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content>
            {{
              otherContactInfo &&
              otherContactInfo.length > 1 &&
              otherContactInfo[1].relation
                ? otherContactInfo[1].relation
                : "-"
            }}
          </v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Name :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content
            v-if="
              otherContactInfo &&
              otherContactInfo.length > 1 &&
              otherContactInfo[1].name
            "
          >
            <Phone :phone="otherContactInfo[1].name" />
          </v-list-tile-content>
          <v-list-tile-content v-else>-</v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-list-tile>
      <v-layout row wrap>
        <v-flex sm4>
          <h5>Phone :</h5>
        </v-flex>
        <v-flex sm8>
          <v-list-tile-content
            v-if="
              otherContactInfo &&
              otherContactInfo.length > 1 &&
              otherContactInfo[1].phone
            "
          >
            <Phone :phone="otherContactInfo[1].phone" />
          </v-list-tile-content>
          <v-list-tile-content v-else>-</v-list-tile-content>
        </v-flex>
      </v-layout>
    </v-list-tile>
  </v-list>
</template>
<script>
  import Phone from "@/components/Phone";
  export default {
    props: ["otherContactInfo"],
    components: {
      Phone,
    },
  };
</script>
